import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'

import { fetchCategories, createCategory, editCategory, fetchGroups, resetCategory } from '../../actions/products_actions'

import CategoryForm from '../../components/Products/categoryForm';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  if (values.IsEnabled === null ) {
      errors.IsEnabled = 'Required'
  }
  return errors
}

let categoryForm = reduxForm({
    form: 'categoryForm',
    validate
})(CategoryForm);

function mapStateToProps(state) {
    return {
        groups: state.products.groups,
        groupIsLoading: state.products.groupIsLoading,
        groupError: state.products.groupError,
        currentCategory: state.products.currentCategory,
        initialValues: state.products.currentCategory,
        isCreating: state.products.categoryIsCreating,
        createError: state.products.categoryCreateError,
        created: state.products.categoryCreated,
        isEditing: state.products.categoryIsEditing,
        editError: state.products.categoryEditError,
        edited: state.products.categoryEdited,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { fetchCategories, createCategory, editCategory, fetchGroups, resetCategory })(categoryForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Products/categoryForm.jsx